import { capitalCase } from 'change-case';

export default function getUserName(user: {
  firstName: string | null;
  lastName: string | null;
  email: string;
}) {
  const fullname = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
  if (fullname) {
    return fullname;
  }
  return capitalCase(user.email.split('@')[0]!);
}
